import { useQuery } from "@tanstack/react-query";
import { tariffsApi } from "@/shared/api/tariffs/api-tariffs";
import { type Tariff } from "@/shared/api/types";

export function useTariffByServiceType(serviceType: string | null) {
  const {
    data: tariff,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<Tariff, Error>({
    ...tariffsApi.getTariffByServiceTypeQueryOptions(serviceType!),
    retry: 3,
    enabled: !!serviceType,
  });

  return {
    tariff,
    loading: isLoading,
    isFetching,
    error: error ? error.message : null,
    refetch,
  };
}
